import { resolveObjectKeyLabel, isEnabled, isToolbarOptionEnabled } from './utils';

export const generateFloatingToolbarActions = (prefix = '', config) => {
  if (!prefix) prefix = '';
  let output = [];

  (function traverseConfig(configObj, parentKey = '') {
    Object.entries(configObj).forEach(([key, value]) => {
      const actionKey = resolveObjectKeyLabel(`${parentKey ? parentKey + '-' : ''}${key}`);
      const isEditorConfigObject = typeof value === 'object' && 'enabled' in value;
      if (isEditorConfigObject && isEnabled(value) && isToolbarOptionEnabled(value)) {
        output.push({
          key: actionKey,
          position: value.toolbar.position,
          sortOrder: value.toolbar.order ?? 999,
          showDivider: value.toolbar.showDivider ?? false,
        });
      } else if (typeof value === 'object' && !isEditorConfigObject) {
        traverseConfig(value, actionKey);
      }
    });
  })(config);

  return output.sort((a, b) => a.sortOrder - b.sortOrder);
};
